<template>
  <div class="right-bar__head">
    <h3>ФРВ <br>
      сотрудника</h3>
    <vita-icon class="right-bar-info" name="info-circle-dark" @click="openInfoModal"
               data-qa="right-bar-head-icon-info-open"/>
  </div>
  <vita-info-modal :open="infoModal.open" @toggleInfoModal="closeInfoModal" :title="infoModal.title" modal-icon="info-circle">
    <div class="help-layout">
      <h1>Фонд рабочего времени (ФРВ)</h1>
      <div class="help-layout-grid">
        <div class="help-layout-column">
          <div>
            <h3>ФРВ основного персонала</h3>
            <p>Количество часов, выделенное, запланированное и&nbsp;фактически отработанное основным персоналом аптеки за месяц.</p>
          </div>
          <div>
            <h3>Выделенный ФРВ</h3>
            <p>Количество часов, установленное для отработки
              в&nbsp;учетном периоде.</p>
          </div>
          <div>
            <h3>Фактический ФРВ</h3>
            <p>Количество часов, отработанное в учетном периоде на текущий момент.</p>
          </div>
          <div>
            <h3>Запланированный ФРВ</h3>
            <p>Количество часов, запланированное
              по графику смен.</p>
          </div>
        </div>
        <div class="help-layout-column">
          <div>
            <h3>ФРВ РВ</h3>
            <p>Количество часов, запланированное и&nbsp;отработанное в праздничные дни.</p>
          </div>
          <div>
            <h3>Фактический ФРВ РВ</h3>
            <p>Количество часов, отработанное в&nbsp;праздничные дни.</p>
          </div>
          <div>
            <h3>Запланированный ФРВ РВ</h3>
            <p>Количество часов, запланированное по графику смен в праздничные дни.</p>
          </div>
        </div>
      </div>
      <hr>
      <div class="help-layout-grid bottom-grid">
        <div>
          <div>
            <h3>Обозначение цветов статуса ФРВ</h3>
            <ul class="indicators-list">
              <li>
                <span class="color-indicator green"></span>
                <span>Норма часов</span>
              </li>
              <li>
                <span class="color-indicator orange"></span>
                <span>Недобор часов</span>
              </li>
              <li>
                <span class="color-indicator red"></span>
                <span>Превышение часов</span>
              </li>
            </ul>
          </div>
        </div>
        <div>
          <div>
            <h3>ФРВ сотрудника в графике</h3>
            <img width="400" height="106" src="@/static/img/human-frv-scheme.svg" alt="ФРВ сотрудника в графике" />
          </div>
        </div>
      </div>
    </div>
  </vita-info-modal>
</template>

<script lang="ts" setup>
import VitaInfoModal from '@/components/UI/VitaInfoModal.vue';
import { ref } from 'vue';
import { reachGoal } from '@/utils/metrika';


const infoModal = ref({
  title: 'Справка',
  open: false
})

const closeInfoModal = () => {
  infoModal.value.open = false
}

const openInfoModal = () => {
  infoModal.value.open = true
  reachGoal('timetable-help-click');
}
</script>

<style lang="scss" scoped>
.help-layout {
  h1 {
    margin-bottom: 30px;
  }

  img {
    max-width: 100%;
    height: auto;
  }

  ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  hr {
    display: block;
    margin: 30px 0;
    border-width: .5px;
    background-color: #CCCCCC;
  }

  &-grid {
    display: grid;
    gap: 30px;
    grid-template-columns: minmax(150px, 1fr) minmax(150px, 1fr);

    > div {
      display: flex;
      flex-direction: column;
      gap: 20px;
    }
  }

  .help-layout-column {
    h3 {
      margin-bottom: 4px;
    }

    p {
      font-family: 'Montserrat', sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 15px;
      line-height: 18px;
      color: #333333;
    }
  }

  .bottom-grid h3 {
    margin-bottom: 16px;
  }

  .indicators-list {
    display: flex;
    flex-direction: column;
    gap: 8px;

    li {
      display: flex;
      align-items: center;
      gap: 10px;
    }
  }

  .color-indicator {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #DDDDDD;
    display: inline-block;

    &.red {
      background: #E52E52;
    }

    &.orange {
      background: #FF6F20;
    }

    &.green {
      background: #30B648;
    }
  }
}
</style>